export default __webpack_public_path__ + "static/media/no_image_placeholder.f0b89a30.jpeg";